import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { IpcMainEvent } from '@mona/events';

/**
 * Communicates to the electron shell
 */
@Injectable()
export abstract class MonaRpcService {
    /**
     * Constructor
     *
     * @param window
     */
    constructor(@Inject(WINDOW) protected window: Window) {}

    /**
     * Calls node in an asynchronous
     *
     * @template T Expected result type
     * @param event The event handler registered at the main thread
     * @param payload The payload to send to the event handler
     */
    abstract invoke<T>(event: IpcMainEvent, payload?: any): Promise<any>;
}
